export default __webpack_public_path__ + "static/decoding-AI-driven-personalization-strategies-for-E-commerce-success-b1b3f0ab5f4cda9b7d5b8c6bd033f6d8.png";